import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from './util/http.js'
import base from './util/base.js'
Vue.config.productionTip = false
Vue.use(ElementUI);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
//路由守卫跳转页面返回顶部
router.beforeEach((to, from, next) => {
  // document.body.scrollTop = 0
  // firefox
  // document.documentElement.scrollTop = 0
  // safari
  // window.pageYOffset = 0
  next()
})

